import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LicenseInfo } from "@mui/x-license-pro";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { allColors, blackAndWhiteColors, darkGreenColors, darkGreyColors, lightGreenColors, lightGreyColors, textColors, } from "./treez-colors";
import { lightPalette } from "./treez-palettes";
import { treezTypography } from "./treez-typography";
const treezTheme = createTheme({
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
    palette: Object.assign({}, allColors),
    typography: Object.assign({ allVariants: {
            fontFamily: "Roboto",
        }, button: {
            textTransform: "none",
        } }, treezTypography),
});
const useTreezTheme = () => useTheme();
const TreezThemeProvider = ({ children }) => {
    LicenseInfo.setLicenseKey("2064af6b945a924b463e70c22401fbebTz01MzY3OCxFPTE2OTkxMjIzOTE4MzYsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=");
    return (_jsxs(ThemeProvider, Object.assign({ theme: treezTheme }, { children: [children, _jsx("span", { children: _jsx("link", { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" }) })] })));
};
export { TreezThemeProvider, useTreezTheme, allColors, blackAndWhiteColors, darkGreenColors, darkGreyColors, lightGreenColors, lightGreyColors, textColors, lightPalette, treezTypography, };
